module.exports = __webpack_public_path__ + "img/USDT.d923c768.png";